import { z } from 'zod';

export const orderConditionDetailsSchema = z.object({
  paymentId: z.string().nullable(),
  commercialPolicyId: z.string().nullable(),
  voucherId: z.string().nullable(),
  deliveryAddressId: z.string().nullable(),
  shippingCostValue: z.number().nullable(),
  billingForecastDate: z.date().nullable(),
  internalObservation: z.string().nullable(),
  observation: z.string().nullable(),
});

export type OrderConditionDetailsFormValues = z.infer<typeof orderConditionDetailsSchema>;
